import { gql } from "@apollo/client";


export const UPDATE_SETUP = gql`
mutation UpdateCampaignSetup($updateSetupInput: UpdateSetupInput!) {
  updateCampaignSetup(updateSetupInput: $updateSetupInput) {
    campaignName
    removeDuplicate
    senderEmail
    senderName
    senderNumber
    stopMessage
  }
}
`